/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');
    
    const slideData = {
      products_per_slide: this.products_per,
      mobile_products_per_row: this.mobile_products_per_row,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    let prevNextButtons = false
    if(window.innerWidth > 798){
      if(slideData.products_limit > slideData.products_per_slide){
        prevNextButtons = true
      }else{
        prevNextButtons = false
      }
    }else{
      if(slideData.products_limit > slideData.mobile_products_per_row){
        prevNextButtons = true
      }else{
        prevNextButtons = false
      }
    }

    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: prevNextButtons,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on( 'settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;